import Marquee from 'react-fast-marquee';
import Image from 'next/image';

const LogoMarquee = ({ logos = [] }) => (
  <>
    <div className="hidden sm:block">
      <Marquee gradientColor={[0, 0, 0]}>
        {logos.map((logo, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <picture key={index} className="ml-20 inline-block">
            <Image src={logo.src} width={logo.width} height={logo.height} quality={100} />
          </picture>
        ))}
      </Marquee>
    </div>

    <div className="space-y-12 sm:hidden">
      <Marquee gradientColor={[0, 0, 0]}>
        {logos.slice(0, logos.length / 2).map((logo, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <picture key={index} className="ml-20 inline-block">
            <Image src={logo.src} width={logo.width} height={logo.height} quality={100} />
          </picture>
        ))}
      </Marquee>
      <Marquee gradientColor={[0, 0, 0]}>
        {logos.slice(logos.length / 2, logos.length).map((logo, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <picture key={index} className="ml-20 inline-block">
            <Image src={logo.src} width={logo.width} height={logo.height} quality={100} />
          </picture>
        ))}
      </Marquee>
    </div>
  </>
);

export default LogoMarquee;
